angular.module('access.Nodes')
    .directive('accSigneesList', ['$timeout', 'template', function ($timeout, template) {
        return {
            replace: true,
            scope: {
                esignature: '<'
            },
            link: function ($scope, $element) {
                /**
                 * We'll sort signees by email length in order to maximize the chance
                 * to show fully at least one email address in row.
                 * And as we don't interested in other field, will take only emails.
                 */
                var sortedSignees = $scope.esignature.signees
                    .sort(function (s1, s2) {
                        if (s1.email.length !== s2.email.length) {
                            return s1.email.length - s2.email.length;
                        } else {
                            return s1.email < s2.email ? -1 : s1.email > s2.email ? 1 : 0;
                        }
                    })
                    .map(function (s) { return s.email; });
                $scope.truncated = false;
                $scope.signeesList = _getSigneesList(sortedSignees);

                var signeesAmount = sortedSignees.length;
                var containerElement = $element.parent().get(0);
                var listElement = $element.find('.signees__list').get(0);
                var listElementStyles = window.getComputedStyle(listElement);
                var commaElement = $element.find('.signees__comma').get(0);
                var moreButtonElement = $element.find('.signees__more').get(0);
                var wrapperElement = $('<span />').css({
                    display: 'inline',
                    fontSize: listElementStyles.fontSize,
                    lineHeight: listElementStyles.lineHeight,
                    position: 'absolute',
                    top: '-9999px',
                    left: '-9999px',
                    whiteSpace: 'nowrap'
                }).get(0)


                $scope.$on('windowResize', function (e) {
                    _updateTruncation();
                });

                function _updateTruncation() {
                    if(!$scope.esignature.canShowDetails) {
                        return;
                    }

                    var containerWidth = Math.floor(containerElement.getBoundingClientRect().width);
                    var commaWidth = Math.ceil(commaElement.getBoundingClientRect().width);
                    var moreButtonWidth = Math.ceil(moreButtonElement.getBoundingClientRect().width);

                    window.body.appendChild(wrapperElement);

                    for (var i = signeesAmount; i > 0; i--) {
                        wrapperElement.textContent = _getSigneesList(sortedSignees, i);
                        var wrapperWidth = Math.ceil(wrapperElement.getBoundingClientRect().width);

                        if (wrapperWidth + commaWidth + moreButtonWidth < containerWidth) {
                            $scope.truncated = i !== signeesAmount;
                            break;
                        }
                    }

                    if ($scope.signeesList !== wrapperElement.textContent) {
                        $scope.signeesList = wrapperElement.textContent;
                        $scope.$digest();
                    }

                    window.body.removeChild(wrapperElement);
                }

                /**
                 * Return string containing list of signees emails
                 * @param {object[]} signees List of signees
                 * @param {number} [amount] Amount of items to return (by default return all)
                 * @returns {string} Joined list of signees emails
                 */
                function _getSigneesList(signees, amount) {
                    return signees.slice(0, amount || signees.length).join(', ');
                }

                $timeout(_updateTruncation);
            },
            templateUrl: template('nodes/signees_list')
        }
    }]);
